export const LANDING = '/'
export const SIGN_UP = '/signup'
export const SIGN_IN = '/signin'
export const DEMO = '/demo'
export const USER_SETTINGS = '/settings/user'
export const BILLING_SETTINGS = '/settings/billing'
